import { httpRequest } from "../../http";
import type { AddCorrectionPayload, CorrectionPreview } from "@models/Discrepancy.model";

/** What a correction would do, before it is applied (MPN-2123). Writes nothing. */
export class CommandPreviewCorrection {
  async run(discrepancyId: number, payload: AddCorrectionPayload): Promise<CorrectionPreview> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/discrepancies/${discrepancyId}/corrections/preview/`;
    return httpRequest<CorrectionPreview, AddCorrectionPayload>(url, { method: "POST", body: payload });
  }
}
